
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const ShippingDelivery = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-sm">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Shipping and Delivery Policy</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-gray-600 mb-4">
              CareerGuideKerala.in provides digital products and services. Upon successful payment, 
              the product (such as career guidance reports) will be:
            </p>
            
            <ul className="list-disc pl-6 mb-6 text-gray-600">
              <li className="mb-2">Delivered digitally via email to the registered email address.</li>
              <li className="mb-2">Available for download through your login on our platform.</li>
            </ul>
            
            <p className="text-gray-600 mb-4">
              Delivery is typically instant upon payment confirmation, but in some cases, it may take up to 24 hours 
              if there are technical delays. If you do not receive the product within 24 hours, please contact us at{" "}
              <a href="mailto:careerguidekerala@gmail.com" className="text-brand-blue hover:underline">
                careerguidekerala@gmail.com
              </a>{" "}
              for support.
            </p>
            
            <p className="text-gray-600 mb-4">
              Ensure that you provide a valid and active email address at checkout to avoid delivery issues.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Delivery Methods</h2>
            <p className="text-gray-600 mb-4">
              Our products are delivered through the following methods:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>Direct download from your account dashboard</li>
              <li>Email attachment to your registered email address</li>
              <li>Access links sent to your email</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Delivery Timeframes</h2>
            <p className="text-gray-600 mb-4">
              Most digital products are delivered instantly after payment confirmation. However, 
              certain customized reports may take up to 24 hours to generate and deliver, depending 
              on complexity and system load.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Contact Us</h2>
            <p className="text-gray-600 mb-4">
              If you have any questions about our delivery process or are experiencing issues with 
              receiving your purchase, please contact us at{" "}
              <a href="mailto:careerguidekerala@gmail.com" className="text-brand-blue hover:underline">
                careerguidekerala@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ShippingDelivery;
